import { API_URL } from '@/modules/shared/constants/API_URL'
import { httpAuthenticationInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPAuthenticationInterceptor'
import HTTPExceptionInterceptor from '@/modules/shared/modules/http/domain/services/HTTPExceptionInterceptor'
import { httpTokenInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPTokenInterceptor'

import { ConfigModule } from '../domain/models/ConfigModule'
import { ConfigClientDatasource } from '../infra/ConfigClientDatasource'
import { UpdateConfigClient } from './../../client-config/domain/models/UpdateConfigClient'
import { ConfigClientModule } from './../domain/models/ConfigClientModule'

export const clientConfigDatasourceAdapter: ConfigClientDatasource = {
  async sleepConfig(patientId: string): Promise<ConfigClientModule> {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patient/${patientId}/sleep-config`,
          httpTokenInterceptor({
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )
    const json = ConfigClientModule.parse(await response.json())
    return json
  },
  async updateSleepConfig(
    config: UpdateConfigClient
  ): Promise<ConfigClientModule> {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/sleep-config`,
          httpTokenInterceptor({
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(config)
          })
        )
      )
    )
    const json = ConfigClientModule.parse(await response.json())
    return json
  },
  async remedyConfig(patientId: string): Promise<ConfigClientModule> {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patient/${patientId}/remedy-config`,
          httpTokenInterceptor({
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )
    const json = ConfigClientModule.parse(await response.json())
    return json
  },
  async updateRemedyConfig(
    config: UpdateConfigClient
  ): Promise<ConfigClientModule> {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/remedy-config`,
          httpTokenInterceptor({
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(config)
          })
        )
      )
    )
    const json = ConfigClientModule.parse(await response.json())
    return json
  },
  async photoConfig(patientId: string): Promise<ConfigClientModule> {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patient/${patientId}/photo-config`,
          httpTokenInterceptor({
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )
    const json = ConfigClientModule.parse(await response.json())
    return json
  },
  async updatePhotoConfig(
    config: UpdateConfigClient
  ): Promise<ConfigClientModule> {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/photo-config`,
          httpTokenInterceptor({
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(config)
          })
        )
      )
    )
    const json = ConfigClientModule.parse(await response.json())
    return json
  },
  async liquidConfig(patientId: string): Promise<ConfigClientModule> {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patient/${patientId}/liquid-config`,
          httpTokenInterceptor({
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )
    const json = ConfigClientModule.parse(await response.json())
    return json
  },
  async updateLiquidConfig(
    config: UpdateConfigClient
  ): Promise<ConfigClientModule> {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/liquid-config`,
          httpTokenInterceptor({
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(config)
          })
        )
      )
    )
    const json = ConfigClientModule.parse(await response.json())
    return json
  },
  async foodConfig(patientId: string): Promise<ConfigClientModule> {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patient/${patientId}/food-config`,
          httpTokenInterceptor({
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )
    const json = ConfigClientModule.parse(await response.json())
    return json
  },
  async updateFoodConfig(
    config: UpdateConfigClient
  ): Promise<ConfigClientModule> {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/food-config`,
          httpTokenInterceptor({
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(config)
          })
        )
      )
    )
    const json = ConfigClientModule.parse(await response.json())
    return json
  },
  async bathroomConfig(patientId: string): Promise<ConfigClientModule> {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patient/${patientId}/bathroom-config`,
          httpTokenInterceptor({
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )
    const json = ConfigClientModule.parse(await response.json())
    return json
  },
  async updateBathroomConfig(
    config: UpdateConfigClient
  ): Promise<ConfigClientModule> {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/bathroom-config`,
          httpTokenInterceptor({
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(config)
          })
        )
      )
    )
    const json = ConfigClientModule.parse(await response.json())
    return json
  },
  async getAllModulesConfig(patientId: string): Promise<ConfigModule> {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patient/${patientId}/module-config`,
          httpTokenInterceptor({
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )
    const json = ConfigModule.parse(await response.json())
    return json
  }
}
